import React from 'react';
import Box from '@material-ui/core/Box';
import HomeHero from '../../components/HomeHero';

const Home = () => {
  return (
    <Box component="div" className="home">
      <HomeHero />
    </Box>
  );
}

export default Home;